import { Caption } from 'baseui/form-control/styled-components';
import { themedStyled } from 'common/styles/styletron.theme';
import { string2money } from 'common/utils/string';
import { Input } from 'components/elements';
import { useFormState } from 'components/elements/form';
import Text from 'components/elements/text';
import {
  CardSection,
  HalfContainer,
  SectionContainer as RawSectionContainer,
  SeparatorVertical,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { AgentFormType } from './form-type';

export default function PurchaseSystemCard() {
  const { t } = useTranslation();
  const { control } = useFormContext<AgentFormType>();
  const { isTransactionLimited, remainingTransactionQuota } = useWatch({
    control,
    name: 'system',
  });
  const { editable } = useFormState();

  return (
    <CardSection>
      <SectionContainer>
        <Text variant="HeadingXSmall">{t('agent:purchase_system')}</Text>
        <Input
          type="check-box"
          name="system.isTransactionLimited"
          label={`${t('customer:transaction_limit')}`}
          noMargin
        />
      </SectionContainer>
      <SeparatorVertical $margin={16} />
      <SectionContainer>
        <HalfContainer>
          <Input
            type="number"
            name="system.duePeriod"
            label={t('customer:due_period')}
            placeholder={t('customer:due_period')}
            required
          />
        </HalfContainer>
        <HalfContainer>
          <Input
            type="number"
            name="system.transactionLimit"
            label={t('customer:transaction_limit')}
            placeholder={t('customer:transaction_limit')}
            disabled={!isTransactionLimited}
            required
            caption={
              <>
                {!editable && isTransactionLimited && (
                  <Caption>
                    {t('common:remaining_transaction_quota', {
                      extra: string2money(remainingTransactionQuota),
                    })}
                  </Caption>
                )}
              </>
            }
          />
        </HalfContainer>
      </SectionContainer>
    </CardSection>
  );
}

const SectionContainer = themedStyled(RawSectionContainer, {
  width: '100%',
});
